import Picture from '../Picture';

type SplitBlockProps = {
    children: React.ReactNode;
    alt: string;
    path: string;
    className?: string;
    hasTextFormatting?: boolean;
} & React.HTMLProps<HTMLDivElement>;

export default function SplitBlock({
    children,
    alt,
    path,
    hasTextFormatting = true,
    className = '',
    ...rest
}: SplitBlockProps) {
    let classNames =
        'px-5 md:px-0 py-16 md:py-0 md:w-1/2 text-base md:text-lg lg:text-xl';
    if (hasTextFormatting) {
        classNames +=
            ' prose-ul:ml-0 prose-h4:text-xl prose-h4:lg:text-2xl prose-h3:text-2xl prose-h3:lg:text-3xl prose-h2:text-3xl prose-h2:lg:text-4xl prose-h1:text-4xl prose-h1:lg:text-5xl prose-headings:uppercase prose-h3:lg:3xl prose';
    }

    return (
        <section className={`md:py-20 lg:py-38 ${className}`} {...rest}>
            <div className='md:flex justify-between md:items-center m-auto md:px-5 w-full max-w-6xl'>
                <div className='md:w-5/12 lg:w-3/8'>
                    <Picture
                        path={path}
                        alt={alt}
                        className='md:shadow md:rounded-lg md:h-auto size-[100vw] object-cover md:object-auto'
                    />
                </div>
                <div className={classNames}>{children}</div>
            </div>
        </section>
    );
}
